export default "__VITE_ASSET__CoI0qeWw__"